export const CLIENT_SITE_KEY = '6LfNhSEUAAAAAL9OJM7RO856GguxnnKDM-uveavH'
export const RE_CAPTCHA_API =
    'https://www.google.com/recaptcha/api.js?render=6Ldy0-UZAAAAAJT6bzr6y5NXI9lQ7XJ14O3o6tjF'
export const SCRIPT_SITE_KEY = '6Ldy0-UZAAAAAJT6bzr6y5NXI9lQ7XJ14O3o6tjF'
export const RE_CAPTCHA_POST_URL =
    'https://m03u65lddf.execute-api.eu-west-2.amazonaws.com/reCaptchaWebsiteScore'
